import '../../resources/css/login/ModalAccountConfig.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Modal} from 'react-bootstrap';
import { closeAccountConfig, closeResetPwd } from '../../actions/login/index';
import AccountConfigForm from './AccountConfigForm';
import { closeModal } from '../../actions';

class ModalAccountConfig extends Component {
  constructor(props) {
    super(props);

    this.closeModal = this.closeModal.bind(this);
    this.backAccountConfig = this.backAccountConfig.bind(this);
  }

  closeModal() {
    const { closeAccountConfig } = this.props;
    closeAccountConfig();
  }

  backAccountConfig() {
    const { closeResetPwd } = this.props;
    closeResetPwd();
  }

  render() {
    const { modalStatus, closeModal } = this.props;
    let show = modalStatus === "accountConfig";
    
    return (
      <Modal
        show={show}
        dialogClassName="modal-account-config change-pwd"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // onHide={closeModal(null)}
      >
        <Modal.Header >
          <Modal.Title>
            <span className='icon-change-password'></span>
            <label className='area-header-text'>Change Password</label>
            <span className='icon-btn-close-n' onClick={()=>closeModal(null)}></span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={12}><AccountConfigForm></AccountConfigForm></Col>
          </Row>
        </Modal.Body>
      </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    modalStatus:state.commonReducers.modalStatus,
    showResetPwd: state.loginReducers.showResetPwd
  }
}

export default connect(
  mapStateToProps,
  { closeAccountConfig, closeResetPwd, closeModal }
)(ModalAccountConfig)